import { Languages } from "@beable/content-types";
import {
  BeableCourseType,
  LessonHistoryDataResponse,
  LookupUserDTOV1,
  UserFeedStatsResponse,
  UserScheduleResponse,
} from "@beable/roster-backend-client-v1";

const basicLookupUser = new LookupUserDTOV1();
basicLookupUser.id = '35f69de5-b10e-4f5e-96d9-feca9440dc31';
basicLookupUser.username = 'john.doe.1';
basicLookupUser.firstName = 'John';
basicLookupUser.lastName = 'Doe';
basicLookupUser.primaryLanguage = 'en';
basicLookupUser.userId = '4c57df42-7aab-448e-88da-e9ece24c3ab0';
basicLookupUser.passwordSetByRoster = true;
basicLookupUser.grade = '6';

export const userAccountWithAllContactDetails: LookupUserDTOV1 = {
    ...basicLookupUser,
    siteId: 1,
    userAccountId: 'abc-xyz',
    email: 'user@test.com',
    contactInfo: {
        rosterEmail: 'roster@test.com',
        userProvidedEmail: 'user@test.com'
    }
};

export const userAccountWithEmail: LookupUserDTOV1 = {
    ...basicLookupUser,
    email: 'user@test.com',
    userAccountId: 'abc-xyz',
}

export const userAccountWithNoEmail: LookupUserDTOV1 = {
    ...basicLookupUser,
    userAccountId: 'abc-xyz',
}

export const loginTicketDto: LookupUserDTOV1 = {
    ...basicLookupUser
}

export const lookUpUserResponse: LookupUserDTOV1[] = [
  {
    siteId: 10000,
    id: "874b8832-1b8e-11ea-978f-2e728ce88125",
    userId: "7e76e3e9-a525-4225-9db1-c764cbd5e50f",
    userAccountId: "874b8832-1b8e-11ea-978f-2e728ce88125",
    username: "sara.smith",
    firstName: "Sara",
    lastName: "Smith",
    passwordSetByRoster: false,
    primaryLanguage: "en",
    applicationLanguage: "en",
    grade: "7",
    externalSourceId: ""
  },
  {
    siteId: 10000,
    id: "f2280566-c9b5-4ce1-a21f-a3180df48d5c",
    userId: "f2280566-c9b5-4ce1-a21f-a3180df48d5c",
    username: "login.ticket",
    firstName: "Login",
    lastName: "Ticket",
    passwordSetByRoster: false,
    primaryLanguage: "en",
    grade: "7",
    externalSourceId: ""
  },
];

export const emptyUserProfile: LookupUserDTOV1 = {
  siteId: 0,
  id: "string",
  userId: "string",
  userAccountId: "string",
  username: "string",
  firstName: "string",
  lastName: "string",
  primaryLanguage: "en",
  applicationLanguage: "en",
  passwordSetByRoster: false,
  externalSourceId: "string",
  grade: "123",
};

export const userScheduleResponse: UserScheduleResponse = {
  assignedSections: [
    {
      userAccountId: "7e76e3e9-a525-4225-9db1-c764cbd5e50f",
      siteId: 10000,
      academicSessionId: "f2280566-c9b5-4ce1-a21f-a3180df48d5c",
      sectionTypeCode: "background",
      languageCode: "en",
    },
    {
      userAccountId: "7e76e3e9-a525-4225-9db1-c764cbd5e50f",
      siteId: 10000,
      academicSessionId: "f2280566-c9b5-4ce1-a21f-a3180df48d5c",
      sectionTypeCode: "corereading",
      languageCode: "en",
    },
  ],
  userClasses: [
    {
      classId: "4e59b433-6120-4b69-b7c8-a8dac225586f",
      className: "Demo English Class 1",
    },
    {
      classId: "3e59b433-6120-4b69-b7c8-a8dac225586f",
      className: "Demo English Class 2",
    },
    {
      classId: "5e59b433-6120-4b69-b7c8-a8dac225586f",
      className: "Demo English Class 3",
    },
  ],
  assignedContentCourses: [
    {
      courseId: "508c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseName: "Civics",
      startDt: new Date("2020-10-12T04:00:00.000Z"),
      endDt: new Date("2020-10-14T03:59:59.000Z"),
    },
    {
      courseId: "608c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseName: "US History",
      startDt: new Date("2020-10-12T04:00:00.000Z"),
      endDt: new Date("2020-10-14T03:59:59.000Z"),
    },
    {
      courseId: "908c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseName: "World of Work",
      startDt: new Date("2020-10-12T04:00:00.000Z"),
      endDt: new Date("2020-10-14T03:59:59.000Z"),
    },
    {
      courseId: "74947bc0-096f-11eb-b7fe-d3e59434ab5e",
      courseName: "Health",
      startDt: new Date("2020-10-12T04:00:00.000Z"),
      endDt: new Date("2020-10-14T03:59:59.000Z"),
    },
  ],
  assignedLessons: [
    {
      lessonId: "111c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseId: "508c0be0-096e-11eb-97d6-af1e06ac0ed3",
      lessonName: "To be or not to be",
      classIds: ["4e59b433-6120-4b69-b7c8-a8dac225586f"],
      startDt: new Date("2020-10-12T04:00:00.000Z"),
      endDt: new Date("2020-10-14T03:59:59.000Z"),
      sort: 1,
    },
    {
      lessonId: "222c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseId: "608c0be0-096e-11eb-97d6-af1e06ac0ed3",
      lessonName: "To see or not to see",
      classIds: ["5e59b433-6120-4b69-b7c8-a8dac225586f"],
      startDt: new Date("2020-10-12T04:00:00.000Z"),
      endDt: new Date("2020-10-14T03:59:59.000Z"),
      sort: 2,
    },
    {
      lessonId: "333c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseId: "608c0be0-096e-11eb-97d6-af1e06ac0ed3",
      lessonName: "To eat or not to eat",
      classIds: ["5e59b433-6120-4b69-b7c8-a8dac225586f"],
      startDt: new Date("2020-10-12T04:00:00.000Z"),
      endDt: new Date("2020-10-14T03:59:59.000Z"),
      sort: 3,
    },
    {
      lessonId: "444c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseId: "908c0be0-096e-11eb-97d6-af1e06ac0ed3",
      lessonName: "To sleep or not to sleep",
      classIds: ["3e59b433-6120-4b69-b7c8-a8dac225586f"],
      startDt: new Date("2020-10-12T04:00:00.000Z"),
      endDt: new Date("2020-10-14T03:59:59.000Z"),
      sort: 4,
    },

    {
      lessonId: "555c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseId: "74947bc0-096f-11eb-b7fe-d3e59434ab5e",
      lessonName: "To play or not to play",
      classIds: [
        "4e59b433-6120-4b69-b7c8-a8dac225586f",
        "3e59b433-6120-4b69-b7c8-a8dac225586f",
        "5e59b433-6120-4b69-b7c8-a8dac225586f",
      ],
      startDt: new Date("2020-10-12T04:00:00.000Z"),
      endDt: new Date("2020-10-14T03:59:59.000Z"),
      sort: 5,
    },
  ],
};

export const userFeedStatsResponse: UserFeedStatsResponse = {
  stats: {
    lifetimeDelivered: 10,
    expired: 3,
    queuedLessons: 3,
    lastGeneratedDt: new Date("2020-10-14T03:59:59.000Z"),
    lastRecordCount: 5,
  },
};

export const lessonProgressResponse: LessonHistoryDataResponse = {
  meta: {
    offset: 0,
    limit: 5,
    total: 7,
  },
  results: [
    {
      userAccountId: "874b8832-1b8e-11ea-978f-2e728ce88125",
      firstName: "Sara",
      lastName: "Smith",
      courseId: "74947bc0-096f-11eb-b7fe-d3e59434ab5e",
      courseTitle: "Health",
      lessonId: "555c0be0-096e-11eb-97d6-af1e06ac0ed3",
      lessonTitle: "To play or not to play",
      courseType: BeableCourseType.ACADEMIC,
      primaryLanguage: Languages.English,
      lessonTimeElapsed: 15,
      deliveredAt: new Date("2020-10-12T04:00:00.000Z"),
      sectionStatus: {
        corereading: { 
          activityAttemptId: "555c0be0-096e-11eb-97d6-af1e06ac0ed3",  
          timeElapsed: 5,
          startAt: new Date("2020-10-12T04:00:00.000Z"),
          endAt: new Date("2020-10-12T06:00:00.000Z"),
          score: 100
        },
        wordstudy: {
          activityAttemptId: "555c0be0-096e-11eb-97d6-af1e06ac0ed3",  
          timeElapsed: 5,
          startAt: new Date("2020-10-12T06:00:00.000Z"),
          endAt: new Date("2020-10-12T08:00:00.000Z"),
          score: 100
        },
        background: {
          activityAttemptId: "555c0be0-096e-11eb-97d6-af1e06ac0ed3",  
          timeElapsed: 5,
          startAt: new Date("2020-10-12T06:00:00.000Z"),
          endAt: new Date("2020-10-12T08:00:00.000Z"),
          score: 100
        },
      },
      companionSections: [],
    },
    {
      userAccountId: "874b8832-1b8e-11ea-978f-2e728ce88125",
      firstName: "Sara",
      lastName: "Smith",
      courseId: "908c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseTitle: "World of Work",
      lessonId: "444c0be0-096e-11eb-97d6-af1e06ac0ed3",
      lessonTitle: "To sleep or not to sleep",
      courseType: BeableCourseType.ACADEMIC,
      primaryLanguage: Languages.English,
      lessonTimeElapsed: 15,
      deliveredAt: new Date("2020-10-13T04:00:00.000Z"),
      sectionStatus: {
        corereading: {  
          activityAttemptId: "444c0be0-096e-11eb-97d6-af1e06ac0ed3",
          timeElapsed: 5,
          startAt: new Date("2020-10-13T04:00:00.000Z"),
          endAt: new Date("2020-10-13T06:00:00.000Z"),
          score: 100
        },
        wordstudy: {
          activityAttemptId: "444c0be0-096e-11eb-97d6-af1e06ac0ed3",
          timeElapsed: 5,
          startAt: new Date("2020-10-12T06:00:00.000Z"),
        },
      },
      companionSections: [],
    },
    {
      userAccountId: "874b8832-1b8e-11ea-978f-2e728ce88125",
      firstName: "Sara",
      lastName: "Smith",
      courseId: "508c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseTitle: "Civics",
      lessonId: "111c0be0-096e-11eb-97d6-af1e06ac0ed3",
      lessonTitle: "To be or not to be",
      courseType: BeableCourseType.ACADEMIC,
      primaryLanguage: Languages.English,
      lessonTimeElapsed: 15,
      deliveredAt: new Date("2020-10-14T04:00:00.000Z"),
      sectionStatus: {
        corereading: {  
          activityAttemptId: "111c0be0-096e-11eb-97d6-af1e06ac0ed3",
          timeElapsed: 5,
          startAt: new Date("2020-10-14T04:00:00.000Z"),
          endAt: new Date("2020-10-14T06:00:00.000Z"),
          score: 100
        },
      },
      companionSections: [],
    },
    {
      userAccountId: "874b8832-1b8e-11ea-978f-2e728ce88125",
      firstName: "Sara",
      lastName: "Smith",
      courseId: "608c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseTitle: "US History",
      lessonId: "222c0be0-096e-11eb-97d6-af1e06ac0ed3",
      lessonTitle: "To see or not to see",
      courseType: BeableCourseType.ACADEMIC,
      primaryLanguage: Languages.English,
      lessonTimeElapsed: 15,
      deliveredAt: new Date("2020-10-15T04:00:00.000Z"),
      sectionStatus: {
        wordstudy: {
          activityAttemptId: "222c0be0-096e-11eb-97d6-af1e06ac0ed3",
          timeElapsed: 5,
          startAt: new Date("2020-10-15T06:00:00.000Z"),
          endAt: new Date("2020-10-12T08:00:00.000Z"),
          score: 100
        },
        background: {
          activityAttemptId: "222c0be0-096e-11eb-97d6-af1e06ac0ed3",
          timeElapsed: 5,
          startAt: new Date("2020-10-15T06:00:00.000Z"),
        },
      },
      companionSections: [],
    },
    {
      userAccountId: "874b8832-1b8e-11ea-978f-2e728ce88125",
      firstName: "Sara",
      lastName: "Smith",
      courseId: "608c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseTitle: "US History",
      lessonId: "333c0be0-096e-11eb-97d6-af1e06ac0ed3",
      lessonTitle: "To eat or not to eat",
      courseType: BeableCourseType.ACADEMIC,
      primaryLanguage: Languages.English,
      lessonTimeElapsed: 15,
      deliveredAt: new Date("2020-10-12T04:00:00.000Z"),
      sectionStatus: { },
      companionSections: [],
    },
    {
      userAccountId: "874b8832-1b8e-11ea-978f-2e728ce88125",
      firstName: "Sara",
      lastName: "Smith",
      courseId: "508c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseTitle: "Civics",
      lessonId: "8383udj8-8d9d-33j3-99di-93k393kd9d9d",
      lessonTitle: "To hear or not to hear",
      courseType: BeableCourseType.ACADEMIC,
      primaryLanguage: Languages.English,
      lessonTimeElapsed: 15,
      deliveredAt: new Date("2020-10-17T04:00:00.000Z"),
      sectionStatus: {},
      companionSections: [],
    },
    {
      userAccountId: "874b8832-1b8e-11ea-978f-2e728ce88125",
      firstName: "Sara",
      lastName: "Smith",
      courseId: "608c0be0-096e-11eb-97d6-af1e06ac0ed3",
      courseTitle: "US History",
      lessonId: "848ffuf8-9dk9-33ii-99fd-9f9f9kf99f9f",
      lessonTitle: "To know or not to know",
      courseType: BeableCourseType.ACADEMIC,
      primaryLanguage: Languages.English,
      lessonTimeElapsed: 15,
      deliveredAt: new Date("2020-10-20T04:00:00.000Z"),
      sectionStatus: {},
      companionSections: [],
    }
  ]
}